module.exports = __webpack_public_path__ + "img/IMG-20181201-WA0032.86e1e03e.jpg";